import { toastService } from "../components/ui/toast/toast.service";
import localization from "../config/localization";

const errorModal = {
    showErrorModal: (
        statusCode: number | undefined,
        message: string,
        showToast: boolean = true
    ) => {
        if (statusCode === 401) {
            document.getElementById("session-expired")?.classList.remove("hidden");
            return;
        }

        if (statusCode === 503) {
            if (window.location.pathname !== "/maintenance") {
                window.location.href = "/maintenance";
            }
            return;
        }


        const resolvedMessage =
            message in localization
                ? localization.getString(message as keyof typeof localization)
                : message;

        if (showToast) {
            toastService.error(resolvedMessage);
            return;
        }

        const modal = document.getElementById("common-error-modal");
        if (!modal) return;

        modal.classList.remove("hidden");

        const titleElement = modal.querySelector("h2");
        if (titleElement) {
            titleElement.textContent = resolvedMessage;
        }
    },
};

export default errorModal;